import request from "~/utils/http";

const purchaseOrderApi = {
    gets: async (params) => {
        const url = 'purchase-order';
        return await request.get(url, {params});
    },
    get: async (id) => {
        const url = `purchase-order/detail/${id}`;
        return await request.get(url);
    },
    add: async (params) => {
        const url = 'purchase-order';
        return await request.post(url, params);
    },
    update: async (params) => {
        const url = `purchase-order/${params.id}`;
        return await request.post(url, params);
    },
    delete: async (id) => {
        const url = `purchase-order/delete/${id}`;
        return await request.delete(url);
    }
};

export default purchaseOrderApi;
